import React, {useState} from 'react'
import {Divider, Typography, withStyles} from '@material-ui/core';
import PropTypes from 'prop-types';
import GridBlock from 'components/GridBlock';
import Tr from 'translations/Translations';
import CriteriaElement from './CriteriaElement';
import AddButton from 'components/button/AddButton';
import NewCriteriaPopup from 'components/popup/newCriteria/NewCriteria'
import getObjectValue from 'libs/getObjectValue';
import {CRYTERIUM_TYPE, CRYTERIUM_TYPE_LABEL} from 'components/popup/newCriteria/constants/criterium.type';
import {withRouter} from "react-router";
import {addElementsToParts, removeElementsfromParts} from "../lib/manipulateElementsOnParts";
import ConfirmDeleteCriterion from "./ConfirmDeleteCriterion";
import _ from 'lodash';

const style = theme => ({
    root: {},
    header: {
        marginTop: theme.spacing(1),
        fontWeight: theme.typography.fontWeightBold,
    },
    divider: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    }
})

function CriteriaSection(
    {
        classes,
        formikProps,
        id,
        partId,
        criteriaSumId,
        match,
        stageId,
    }) {
    const [criteriaPopup, setCriteriaPopup] = useState(false)
    const [editElement, setEditElement] = useState();
    const [openDeletePopup, setOpenDeletePopup] = useState(false);
    const demandId = match.params.id;
    const editable = getObjectValue('_editable', formikProps.values, true);

    const thisId = id;

    const elements = getObjectValue(thisId, formikProps.values, [])

    const handleAddCriteria = ({parts, ...values}) => {
        addElementsToParts(formikProps, id, parts, values, editElement, demandId);
        setCriteriaPopup(false);
        setEditElement();
    }

    const handleEdit = (index) => {
        setEditElement(_.cloneDeep(elements[index]));
        setCriteriaPopup(true);
    }

    const criteriaSumError = getObjectValue(criteriaSumId, formikProps.errors, [])
    const isError = !!criteriaSumError;

    const handleDeleteButtonPress = (index) => {
        setEditElement(_.cloneDeep(elements[index]));
        setOpenDeletePopup(true);
    }

    const onCloseDeletePopup = () => {
        setOpenDeletePopup(false)
        setEditElement();
    }

    const handleDeleteCondition = ({parts}) => {
        removeElementsfromParts(formikProps, id, parts, editElement, demandId);
        setOpenDeletePopup(false);
        setEditElement();
    }


    return (
        <>
            <GridBlock
                className={classes.root}
                direction='column'
            >
                <Typography
                    variant='body1'
                    className={classes.header}
                >
                    {Tr('criteria')}({elements.length})
                </Typography>
                <GridBlock alignItems='center'>
                    {
                        elements.map((item, i) => {
                            let name = item.type === CRYTERIUM_TYPE.OTHER ? item.otherName : CRYTERIUM_TYPE_LABEL[item.type];
                            if (item.type === CRYTERIUM_TYPE.PRICE
                                && Boolean(item.otherName)) {
                                name = item.otherName;
                            }
                            return (
                                <CriteriaElement
                                    key={i}
                                    name={name}
                                    type={item.type}
                                    formikProps={formikProps}
                                    onDelete={handleDeleteButtonPress}
                                    id={thisId}
                                    index={i}
                                    onEdit={() => handleEdit(i)}
                                    disabled={!editable}
                                />
                            )
                        })
                    }

                    <AddButton
                        disabled={!editable}
                        onClick={() => {
                            setEditElement()
                            setCriteriaPopup(true)
                        }}>
                        {Tr('add_criteria')}
                    </AddButton>
                </GridBlock>

                {(isError) &&
                <Typography variant='body1' color='error'>
                    {criteriaSumError}
                </Typography>
                }
                <Divider className={classes.divider}/>
            </GridBlock>
            {criteriaPopup && <NewCriteriaPopup
                onAdd={handleAddCriteria}
                onClose={() => setCriteriaPopup(false)}
                partId={partId}
                selectedItems={elements}
                initValues={editElement}
                elementList={formikProps.values.form}
                demandId={demandId}
                stageId={stageId}
                showParts={editable}
            />}
            {openDeletePopup && <ConfirmDeleteCriterion
                onClose={() => onCloseDeletePopup()}
                onDelete={handleDeleteCondition}
                partId={partId}
                demandId={demandId}
                stageId={stageId}
                initCrit={editElement}
                allItems={formikProps.values.form}
                id={id}
            />}
        </>
    )
}

CriteriaSection.propTypes = {
    classes: PropTypes.any,
}

export default withStyles(style)(withRouter(CriteriaSection));